import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { TrendDetectionService } from 'features/trend-detection/service/service'

export function useTrendDetectionService(): TrendDetectionService {
  const client = useApiClient()
  return useMemo(() => new TrendDetectionService(client), [client])
}
